import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TaskWorkspaceStore } from '../../../../../core/h3ml/state/task-workspace-store';
import { objectIcon } from '../../../../../core/shared/icons/object-icon';
import { settingsIcon } from '../../../../../core/shared/icons/side-panel/settings-icon';
import { SidePanelTabName } from '../../../../../team-apis/core/side-panel';
import { annotationTabName, settingsTabName } from '../side-panel.component';

@Component({
  selector: 'h3-side-panel-tabs',
  templateUrl: './side-panel-tabs.component.html',
  styleUrl: './side-panel-tabs.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SidePanelTabsComponent {
  private readonly store = inject(TaskWorkspaceStore);
  private readonly sidePanelStore = this.store('sidePanel');

  buttons = this.buildButtons();
  selectedTab$ = this.sidePanelStore('selectedTabName').$;

  setSelectedTab(tabName: SidePanelTabName) {
    this.sidePanelStore('selectedTabName').set(tabName);
  }

  private buildButtons() {
    const buttons = [
      { tabName: annotationTabName, icon: objectIcon, tooltip: 'Objects' },
    ];

    if (!this.store.isUsingGenAi()) {
      buttons.push({
        tabName: settingsTabName,
        icon: settingsIcon,
        tooltip: 'Settings',
      });
    }

    return buttons;
  }
}
